import Enumerator from './Enumerator';

export const timeUnitTypes = ['minutes', 'hours', 'days', 'weeks', 'months', 'years'];

export class TimeUnitType extends Enumerator {
  static default() {
    return this.of('minutes');
  }
}
TimeUnitType.initEnum({
  minutes: {
    get id() {
      return 'minutes';
    }
  },
  hours: {
    get id() {
      return 'hours';
    }
  },
  days: {
    get id() {
      return 'days';
    }
  },
  weeks: {
    get id() {
      return 'weeks';
    }
  },
  months: {
    get id() {
      return 'months';
    }
  },
  years: {
    get id() {
      return 'years';
    }
  }
});

export default {
  timeUnitTypes,
  TimeUnitType
};
